import { render } from "./Fragrances.vue?vue&type=template&id=46a32e68"
import script from "./Fragrances.vue?vue&type=script&lang=js"
export * from "./Fragrances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__